import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../services/api';
import TCLogo from './TCLogo';

const ForgotPassword = () => {
  const { org_slug } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword({ email, org_slug });
    } catch (err) {}
    finally {
      setSubmitted(true);
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg, #1B3A5C 0%, #2E75B6 100%)',padding:'20px'}}>
      <div style={{background:'white',borderRadius:'12px',padding:'40px',width:'100%',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <TCLogo size={56} />
          <h1 style={{fontSize:'24px',fontWeight:'700',color:'#1B3A5C',marginTop:'12px',marginBottom:'4px'}}>Reset Password</h1>
          <p style={{color:'#595959',fontSize:'13px'}}>CONSAM DMS</p>
        </div>
        {submitted ? (
          <div style={{textAlign:'center',padding:'8px'}}>
            <div style={{fontSize:'48px',color:'#1E7B34',marginBottom:'16px'}}>✓</div>
            <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1B3A5C',marginBottom:'8px'}}>Check your email</h3>
            <p style={{color:'#595959',fontSize:'14px',lineHeight:'1.6'}}>
              If that email exists, a reset link has been sent. The link expires in 1 hour.
            </p>
            <button className="btn btn-primary"
              onClick={() => navigate(`/${org_slug}/login`)}
              style={{width:'100%',marginTop:'16px',padding:'12px'}}>
              Back to Login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email" required autoFocus />
            </div>
            <button type="submit" className="btn btn-primary"
              style={{width:'100%',padding:'12px',fontSize:'15px',marginTop:'8px'}}
              disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <div style={{textAlign:'center',marginTop:'16px'}}>
              <a href={`/${org_slug}/login`} style={{color:'#2E75B6',textDecoration:'none',fontSize:'13px'}}>
                ← Back to Login
              </a>
            </div>
          </form>
        )}
      </div>
      <p style={{color:'rgba(255,255,255,0.5)',fontSize:'11px',marginTop:'20px'}}>
        © 2026 CONSAM. All rights reserved.
      </p>
    </div>
  );
};

export default ForgotPassword;
